<template>
  <div class="tabs">
    <ul v-if="tabs.length">
      <li v-for="(tab, index) in tabs" :key="index">
        <button
          @click="$emit('input', index)"
          :class="index === active ? 'active' : ''"
        >
          {{ tab.title | tab.key | setText(tab.title) }}
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "Search",
  data() {
    return {};
  },
  props: {
    tabs: {
      type: Array,
      default: [],
    },
    active: {
      default: 0,
    },
  },
};
</script>
<style>
</style>
